// extracted by mini-css-extract-plugin
export var facultyFilterContainer = "LifetimeFacultyFilter-module--facultyFilterContainer--KeKY7";
export var facultyFilterDefaultItem = "LifetimeFacultyFilter-module--facultyFilterDefaultItem--YweHg";
export var facultyFilterDropdown = "LifetimeFacultyFilter-module--facultyFilterDropdown--OqtO3";
export var facultyFilterDropdownItem = "LifetimeFacultyFilter-module--facultyFilterDropdownItem--7hMZe";